import { render } from "./menubar.vue?vue&type=template&id=7d2e5568&scoped=true"
import script from "./menubar.vue?vue&type=script&lang=js"
export * from "./menubar.vue?vue&type=script&lang=js"

import "./menubar.vue?vue&type=style&index=0&id=7d2e5568&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2e5568"]])

export default __exports__